import { render, staticRenderFns } from "./delivery-detail.vue?vue&type=template&id=de97d59a&scoped=true&"
import script from "./delivery-detail.vue?vue&type=script&lang=js&"
export * from "./delivery-detail.vue?vue&type=script&lang=js&"
import style0 from "./delivery-detail.sass?vue&type=style&index=0&id=de97d59a&scoped=true&lang=sass&"
import style1 from "./delivery-detail.vue?vue&type=style&index=1&id=de97d59a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de97d59a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/goeatBackup/goeat-backup-goeat-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBreadcrumbs,VBtn,VCard,VCardActions,VCardTitle,VCheckbox,VContainer,VDialog,VFlex,VIcon,VLayout,VProgressCircular,VSpacer})
